// AdminAuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const fullName = localStorage.getItem("fullName");
    const profileImage = localStorage.getItem("profileImage");
    const initials = localStorage.getItem("initials");

    if (storedToken && fullName) {
      setAdmin({
        token: storedToken,
        fullName,
        profileImage,
        initials,
        role: "admin",
      });
    }
  }, []);

  const login = (adminData) => {
    const initials = adminData.fullName
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();

    localStorage.setItem("token", adminData.token);
    localStorage.setItem("role", "admin");
    localStorage.setItem("fullName", adminData.fullName);
    localStorage.setItem("profileImage", adminData.profileImage || "");
    localStorage.setItem("initials", initials);
    localStorage.setItem("isAuthenticated", "true");

    setAdmin({
      ...adminData,
      initials,
      role: "admin",
    });
  };

  const logout = () => {
    localStorage.clear();
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
